<template>
  <Icon>
    <svg slot="svg" width="16px" height="19px" viewBox="0 0 16 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
        <path d="M7.199952,3 L16.800048,3 L16.800048,4.5834125 L7.199952,4.5834125 L7.199952,3 Z M5.599856,6.1665875 L18.400144,6.1665875 L18.400144,7.75 L5.599856,7.75 L5.599856,6.1665875 Z M4,9.3334125 L20,9.3334125 L18.400144,22 L5.599856,22 L4,9.3334125 Z M16.9874899,20.4165875 L18.1877419,10.9165875 L5.81249812,10.9165875 L7.01251013,20.4165875 L16.9874899,20.4165875 Z" id="path-1-administration-icon"></path>
      </defs>
      <g id="blocks/menu" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-20.000000, -182.000000)">
        <g id="menu">
          <g id="Stacked-Group" transform="translate(16.000000, 16.000000)">
            <g id="menu/item-copy-8" transform="translate(0.000000, 163.000000)">
              <g id="icons/menu_administracja">
                <rect id="Bounding-Box" x="0" y="0" width="24" height="24"></rect>
                <mask id="mask-2" fill="white">
                  <use xlink:href="#path-1-administration-icon"></use>
                </mask>
                <use id="Combined-Shape" fill="#43CEA2" fill-rule="nonzero" xlink:href="#path-1-administration-icon"></use>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </Icon>
</template>

<script>
import Icon from "./icon";

export default {
  name: "DsAdministrationIcon",
  components: {
    Icon
  }
};
</script>



// WEBPACK FOOTER //
// ../panel-theme/src/js/icons/ds-administration-icon.vue